import assetPath from '/app/packages/lebenslauf/articles/src/assets/bewerbungsfoto.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')